function forgotten() {
    return { 
        template : require('./wai.forgotten.html') 
    };
};
export default forgotten;


// WEBPACK FOOTER //
// ./src/login/forgotten/wai.forgotten.js